<template>
    <div class="report">
        <div class="title-row">
            <div class="title-column">
                <positive :color="color" :width="50" :height="50" />
                <span class="count">
                    {{ positiveCount }}
                </span>
                <span class="report-title">
                    {{ $t('talk.request.positive.name').toUpperCase() }}
                </span>
            </div>
            <div class="title-column">
                <improvement :color="color" :width="40" :height="50" />
                <span class="count">{{ improvementCount }}</span>
                <span class="report-title">
                    {{ $t('talk.request.improvement.name').toUpperCase() }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { Positive, Improvement } from '@/views/talk/components'
import { EventBuzz } from '@/main'
import { getCategoryCount } from './api'

export default {
    name: 'CategoryReport',
    components: {
        Positive,
        Improvement,
    },
    data() {
        return {
            color: '#009BDB',
            filters: {},
            role: 'user',
            count: {
                improvement: null,
                positive: null,
            },
        }
    },
    mounted() {
        this.getReport()
        EventBuzz.$on('update-talk-summary', this.getReport)
        EventBuzz.$on('feedback-filters-changed', this.setFilters)
        EventBuzz.$on('roleChanged', this.setRole)
    },
    methods: {
        getReport() {
            getCategoryCount(this.currentUser.id, this.filters, this.role)
                .then(res => {
                    this.count = { ...res }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        setFilters(filters) {
            this.filters = filters
        },
        setRole(role) {
            this.role = role
        },
    },
    watch: {
        role() {
            this.getReport()
        },
        filters() {
            this.getReport()
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        positiveCount() {
            return this.count.positive ? this.count.positive : '-'
        },
        improvementCount() {
            return this.count.improvement ? this.count.improvement : '-'
        },
    },
}
</script>

<style lang="sass" scoped>
@import './style'

.title-row
    flex-direction: row !important
    justify-content: space-around !important
    height: 100% !important
    .title-column
        height: 100%
        display: flex
        flex-direction: column
        align-items: center
        justify-content: space-between
        padding: 10px 0
        .report-tile
            display: flex
            justify-content: center
            align-items: center
</style>
